import { useState } from 'react'
import type { ToteEngagementMode } from '@mote/api'
import { ToteEngagementModeEnum } from '@mote/api'

export type CarouselMap = {
  assistiveCarousel: string[]
  affirmativeCarousel: string[]
}

export type UseCarousel = {
  rotate: (rotatedCarouselMap: CarouselMap) => void
  first: (mode: ToteEngagementMode) => string
}

export function useCarousel(initialCarouselMap: CarouselMap): UseCarousel {
  const [carousels, setCarousels] = useState(initialCarouselMap)
  return {
    first: mode => {
      if (mode === ToteEngagementModeEnum.ASSISTIVE) {
        return carousels.assistiveCarousel[0]
      }
      return carousels.affirmativeCarousel[0]
    },
    rotate: rotatedCarouselMap => setCarousels(rotatedCarouselMap)
  }
}
